import { call, put, takeEvery } from '@redux-saga/core/effects';
import { ActionType } from 'typesafe-actions';
import {
  DELETE_MESSAGE,
  DUPLATE_MESSAGE,
  ERROR_MESSAGE,
  SAVE_MESSAGE
} from '../../../../configs/constants';
import * as MessageActions from '../../../comn/message/actions/comnMessageAction';
import * as Actions from '../actions/basisFlightAction';
import * as Apis from '../apis/basisFlightApi';
import { FlightPlanData } from '../models/basisFlightModel';
import {
  FLIGHT_PLAN_ARCRFT_LIST,
  FLIGHT_PLAN_CREATE,
  FLIGHT_PLAN_DELETE,
  FLIGHT_PLAN_DETAIL,
  FLIGHT_PLAN_PILOT_LIST,
  FLIGHT_PLAN_UPDATE
} from '../actions/basisFlightAction';

function* listAreaSaga(
  action: ActionType<typeof Actions.PUBLIC_AREA_LIST.request>
) {
  try {
    const response = yield call(Apis.flightPlanAPI.area);

    if (response.errorCode) {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: response.errorCode,
          errorMessage: response.errorMessage,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      return;
    }

    yield put(
      Actions.PUBLIC_AREA_LIST.success({
        data: response
      })
    );
  } catch (error: any) {
    yield put(Actions.PUBLIC_AREA_LIST.failure(error));
  }
}

// 비행계획서 목록
function* listPlanSaga(
  action: ActionType<typeof Actions.FLIGHT_PLAN_LIST.request>
) {
  try {
    const data = action.payload;
    const response = yield call(Apis.flightPlanAPI.list, data);
    if (response.errorCode) {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: response.errorCode,
          errorMessage: response.errorMessage,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      return;
    }

    yield put(Actions.FLIGHT_PLAN_LIST.success(response.data));
  } catch (error: any) {
    yield put(Actions.FLIGHT_PLAN_LIST.failure(error));
  }
}

// 비행계획서 상세
function* detailPlanSaga(
  action: ActionType<typeof Actions.FLIGHT_PLAN_DETAIL.request>
) {
  try {
    const data = action.payload;
    const response = yield call(Apis.flightPlanAPI.detail, data);
    if (response.errorCode) {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: response.errorCode,
          errorMessage: response.errorMessage,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      return;
    }

    yield put(Actions.FLIGHT_PLAN_DETAIL.success(response.data));
  } catch (error: any) {
    yield put(Actions.FLIGHT_PLAN_DETAIL.failure(error));
  }
}
//비행 구역 설정 날씨 API
function* WeatherSaga(
  action: ActionType<typeof Actions.FlightweatherAction.request>
) {
  try {
    const rq = action.payload;
    const data = yield call(Apis.flightPlanAPI.apiweather, rq);
    yield put(Actions.FlightweatherAction.success(data));
  } catch (error) {
    yield put(Actions.FlightweatherAction.failure(error));
  }
}
// 비행계획서 등록
function* createPlanSaga(
  action: ActionType<typeof Actions.FLIGHT_PLAN_CREATE.request>
) {
  try {
    const detail = action.payload;

    const res = yield call(Apis.flightPlanAPI.create, detail);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: false
        })
      );
    } else {
      if (data.errorCode === 'DT002') {
        yield put(
          MessageActions.IS_ERROR({
            errorCode: DUPLATE_MESSAGE.code,
            errorMessage: '제작번호 ' + DUPLATE_MESSAGE.message,
            isHistoryBack: false,
            isRefresh: false
          })
        );
      } else if (data.errorCode === 'FT500') {
        yield put(
          MessageActions.IS_ERROR({
            errorCode: DUPLATE_MESSAGE.code,
            errorMessage: data.errorMessage,
            isHistoryBack: false,
            isRefresh: false
          })
        );
      } else {
        throw Error;
      }
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.FLIGHT_PLAN_CREATE.failure(error));
  }
}

// 비행계획서 수정
function* updatePlanSaga(
  action: ActionType<typeof Actions.FLIGHT_PLAN_UPDATE.request>
) {
  try {
    const detail = action.payload;

    const res = yield call(Apis.flightPlanAPI.update, detail);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: false
        })
      );
    } else {
      if (data.errorCode === 'DT002') {
        yield put(
          MessageActions.IS_ERROR({
            errorCode: DUPLATE_MESSAGE.code,
            errorMessage: '제작번호 ' + DUPLATE_MESSAGE.message,
            isHistoryBack: false,
            isRefresh: false
          })
        );
      } else {
        throw Error;
      }
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.FLIGHT_PLAN_UPDATE.failure(error));
  }
}

// 비행계획서 삭제
function* deletePlanSaga(
  action: ActionType<typeof Actions.FLIGHT_PLAN_DELETE.request>
) {
  try {
    const id = action.payload;
    const res = yield call(Apis.flightPlanAPI.delete, id);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: DELETE_MESSAGE.code,
          message: DELETE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: false
        })
      );
    } else {
      throw Error;
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.FLIGHT_PLAN_DELETE.failure(error));
  }
}

// 조종사 목록
function* listPilotSaga(
  action: ActionType<typeof Actions.FLIGHT_PLAN_PILOT_LIST.request>
) {
  try {
    const data = action.payload;
    const response = yield call(Apis.flightPlanAPI.listPilot, data);
    if (response.errorCode) {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: response.errorCode,
          errorMessage: response.errorMessage,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      return;
    }

    yield put(Actions.FLIGHT_PLAN_PILOT_LIST.success(response.data));
  } catch (error: any) {
    yield put(Actions.FLIGHT_PLAN_PILOT_LIST.failure(error));
  }
}

// 기체 목록
function* listArcrftSaga(
  action: ActionType<typeof Actions.FLIGHT_PLAN_ARCRFT_LIST.request>
) {
  try {
    const data = action.payload;
    const response = yield call(Apis.flightPlanAPI.listArcrft, data);
    if (response.errorCode) {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: response.errorCode,
          errorMessage: response.errorMessage,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      return;
    }

    yield put(Actions.FLIGHT_PLAN_ARCRFT_LIST.success(response.data));
  } catch (error: any) {
    yield put(Actions.FLIGHT_PLAN_ARCRFT_LIST.failure(error));
  }
}

// get buffer list
function* listBuffer(
  action: ActionType<typeof Actions.FLIGHT_PLAN_AREA_BUFFER_LIST.request>
) {
  try {
    const data = action.payload;
    const response = yield call(Apis.flightPlanAPI.listBuffer, data);
    if (response.errorCode) {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: response.errorCode,
          errorMessage: response.errorMessage,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      return;
    }

    yield put(Actions.FLIGHT_PLAN_AREA_BUFFER_LIST.success(response.data));
  } catch (error: any) {
    yield put(Actions.FLIGHT_PLAN_AREA_BUFFER_LIST.failure(error));
  }
}

// 비행계획서 목록(승인)
function* listAprvSaga(
  action: ActionType<typeof Actions.FLIGHT_APRV_LIST.request>
) {
  try {
    const data = action.payload;
    const response = yield call(Apis.flightPlanAPI.aprvList, data);
    if (response.errorCode) {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: response.errorCode,
          errorMessage: response.errorMessage,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      return;
    }

    yield put(Actions.FLIGHT_APRV_LIST.success(response.data));
  } catch (error: any) {
    yield put(Actions.FLIGHT_APRV_LIST.failure(error));
  }
}

// 비행계획서 승인
function* aprvProcSaga(
  action: ActionType<typeof Actions.FLIGHT_APRV_PROC.request>
) {
  try {
    const sendData = action.payload;

    const res = yield call(Apis.flightPlanAPI.aprvProc, sendData);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      yield put(Actions.FLIGHT_APRV_PROC.success(data));
    } else {
      if (data.errorCode === 'DT002') {
        yield put(
          MessageActions.IS_ERROR({
            errorCode: DUPLATE_MESSAGE.code,
            errorMessage: '제작번호 ' + DUPLATE_MESSAGE.message,
            isHistoryBack: false,
            isRefresh: false
          })
        );
      } else {
        throw Error;
      }
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.FLIGHT_PLAN_UPDATE.failure(error));
  }
}

// 비행계획서 목록
function* scheduleListSaga(
  action: ActionType<typeof Actions.FLIGHT_SCHEDULE_LIST.request>
) {
  try {
    const data = action.payload;
    const response = yield call(Apis.flightPlanAPI.scheduleList, data);

    if (response.errorCode) {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: response.errorCode,
          errorMessage: response.errorMessage,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      return;
    }

    yield put(Actions.FLIGHT_SCHEDULE_LIST.success(response.data || []));
  } catch (error: any) {
    yield put(Actions.FLIGHT_SCHEDULE_LIST.failure(error));
  }
}

function* searchAreaSaga(
  action: ActionType<typeof Actions.SEARCH_AREA.request>
) {
  try {
    const { query } = action.payload;

    const res = yield call(Apis.flightPlanAPI.searchArea, { query });
    yield put(Actions.SEARCH_AREA.success(res));
  } catch (error) {
    yield put(Actions.SEARCH_AREA.failure(error));
  }
}

// get uam buffer list
function* uamBufferListSaga(
  action: ActionType<typeof Actions.FLIGHT_UAM_BUFFER_LIST.request>
) {
  try {
    const data = action.payload;
    const response = yield call(Apis.flightPlanAPI.uamBufferList, data);
    if (response.errorCode) {
      yield put(
        MessageActions.IS_ERROR({
          errorCode: response.errorCode,
          errorMessage: response.errorMessage,
          isHistoryBack: false,
          isRefresh: false
        })
      );
      return;
    }

    yield put(Actions.FLIGHT_UAM_BUFFER_LIST.success(response));
  } catch (error: any) {
    yield put(Actions.FLIGHT_UAM_BUFFER_LIST.failure(error));
  }
}

export function* flightSaga() {
  yield takeEvery(Actions.PUBLIC_AREA_LIST.request, listAreaSaga);
  // yield takeEvery(Actions.FLIGHT_PLAN_AREA.request, createFlightPlanArea);
  yield takeEvery(Actions.FLIGHT_PLAN_LIST.request, listPlanSaga);
  yield takeEvery(Actions.FLIGHT_PLAN_DETAIL.request, detailPlanSaga);
  yield takeEvery(Actions.FLIGHT_PLAN_CREATE.request, createPlanSaga);
  yield takeEvery(Actions.FLIGHT_PLAN_UPDATE.request, updatePlanSaga);
  yield takeEvery(Actions.FLIGHT_PLAN_DELETE.request, deletePlanSaga);
  yield takeEvery(Actions.FLIGHT_PLAN_PILOT_LIST.request, listPilotSaga);
  yield takeEvery(Actions.FLIGHT_PLAN_ARCRFT_LIST.request, listArcrftSaga);
  yield takeEvery(Actions.FLIGHT_PLAN_AREA_BUFFER_LIST.request, listBuffer);
  yield takeEvery(Actions.FLIGHT_APRV_LIST.request, listAprvSaga);
  yield takeEvery(Actions.FLIGHT_APRV_PROC.request, aprvProcSaga);
  yield takeEvery(Actions.SEARCH_AREA.request, searchAreaSaga);
  yield takeEvery(Actions.FLIGHT_SCHEDULE_LIST.request, scheduleListSaga);
  yield takeEvery(Actions.FlightweatherAction.request, WeatherSaga);
  yield takeEvery(Actions.FLIGHT_UAM_BUFFER_LIST.request, uamBufferListSaga);
}
